module.exports = __webpack_public_path__ + "img/63.cfb17f9a.png";